// LOOK BOOK グリッド：モーダル内クリックで前後の画像切替
(() => {
  const MODAL_SELECTOR = 'lookbook-modal-dialog.lookbook-media-modal--grid';
  const ITEM_SELECTOR = 'img[data-lookbook-grid-item]';

  function setImageFromIndex(modal, items, index) {
    if (!items.length) return;

    const total = items.length;
    const nextIndex = ((index % total) + total) % total;
    const item = items[nextIndex];

    const mainImg = modal.querySelector('[data-lookbook-grid-main-img]');
    if (mainImg && item) {
      mainImg.src = item.getAttribute('src') || '';
      mainImg.alt = item.getAttribute('alt') || '';
    }

    modal.dataset.lookbookGridCurrentIndex = String(nextIndex);
  }

  function initModal(modal) {
    const mainImg = modal.querySelector('[data-lookbook-grid-main-img]');
    const items = Array.from(modal.querySelectorAll(ITEM_SELECTOR)).sort((a, b) => {
      return Number(a.dataset.lookbookGridIndex || 0) - Number(b.dataset.lookbookGridIndex || 0);
    });
    const content = modal.querySelector('.lookbook-media-modal__content');

    // mainImgが無いと動かないので中断
    if (!mainImg || !items.length || !content) return;

    const syncFromOpenedBy = () => {
      const opener = modal.openedBy;
      const indexRaw = opener?.dataset?.lookbookGridIndex;
      const index = indexRaw !== undefined ? Number(indexRaw) : 0;
      setImageFromIndex(modal, items, index);
    };

    // modal-dialog の open 属性変更を監視（openイベントが無いので）
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open' && modal.hasAttribute('open')) {
          syncFromOpenedBy();
        }
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

    // クリックで左右判定して前後に切替
    content.addEventListener('click', (event) => {
      if (!modal.hasAttribute('open')) return;

      // CTA/クローズ/リンク類は切替対象外
      const ignore = event.target.closest('a, button, [role="button"]');
      if (ignore && !ignore.closest('[data-lookbook-grid-main-img]')) return;

      const rect = mainImg.getBoundingClientRect();
      if (!rect.width) return;

      const clickX = event.clientX - rect.left;
      const direction = clickX < rect.width / 2 ? -1 : 1;

      const current = Number(modal.dataset.lookbookGridCurrentIndex || '0');
      setImageFromIndex(modal, items, current + direction);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const modals = document.querySelectorAll(MODAL_SELECTOR);
    modals.forEach((modal) => initModal(modal));
  });
})();

